import { ModelDefaults } from './ModelDefaults.js';
import { ToTitleCase } from './ToTitleCase.js';

export function StyleRuleToIcon(styleProperties, isLiteTier, options) {
  options = options || {};
  const modelDefaults = options.modelDefaults || ModelDefaults();
  // the value of styleProperties can be objects and strings, so we need to handle both correctly
  let stylePropertiesValue =
    typeof styleProperties.value == 'object' ? (Object.values(styleProperties.value)[0] ?? null) : (styleProperties.value ?? null);

  // Build the style and title values
  var style = '';
  var parentStyle = '';
  var title = '';

  // Set the color and pattern style
  if (styleProperties.color) style += 'color: ' + styleProperties.color + ';';
  if (styleProperties.pattern) {
    let pattern = styleProperties.pattern;
    parentStyle = 'width:60px;';
    if (['dashed', 'solid'].includes(pattern)) {
      style += 'border-style: ' + pattern + ';';
      style += 'width: 100%; height:0px; border-width:2px;';
    } else {
      let length = pattern
        .split(' ')
        .map(Number)
        .reduce((a, b) => a + b, 0);
      let strokeWidth = Number(styleProperties.width) / 2;
      let background = `background: url("data:image/svg+xml,<svg width='60' height='10' viewBox='0 0 ${length} 10' xmlns='http://www.w3.org/2000/svg'><line x1='0' y1='${
        strokeWidth / 2
      }' y2='${strokeWidth / 2}' stroke='${
        styleProperties.color?.replace('#', '%23') || 'black'
      }' x2='${length}' stroke-width='${strokeWidth}' stroke-dasharray='${pattern}' stroke-linecap='round'></line></svg>") no-repeat;`;
      style += background + 'width: 100%; height:10px;';
    }
  }
  // If there is a pattern and no icon, assume it's a cable and force size to be horizontal bar
  else if (styleProperties.icon) {
    // Otherwise, set the given size
    if (styleProperties.size) style += 'width: ' + styleProperties.size + 'px; height: ' + styleProperties.size + 'px;';
  }

  if (styleProperties.label) {
    title = styleProperties.label;
  } else if (
    styleProperties.attribute == modelDefaults.node_type_attribute ||
    styleProperties.attribute == modelDefaults.connection_type_attribute ||
    styleProperties.attribute == 'reference_type'
  ) {
    // Show value as title if type is node_type, connection_type, or reference_type
    title += ToTitleCase(stylePropertiesValue || '');
  } else if (styleProperties.comparator == 'has' || stylePropertiesValue == '!null') {
    // Otherwise, show just the attribute if the comparator is 'has', or the value is '!null'
    title += ToTitleCase(styleProperties.attribute || '');
  } else if (styleProperties.comparator == 'does not have' || stylePropertiesValue === 'null') {
    // If the comparator is 'does not have' or the value is 'null', then the style is applied when the attribute doesn't exist
    title += ToTitleCase(styleProperties.attribute || '') + ": doesn't exist";
  } else if (isLiteTier && styleProperties.attribute == 'done' && stylePropertiesValue === true) {
    title += 'Completed Pole';
  } else {
    // Otherwise, show the title as "attribute = value" or "attribute ≠ value"
    if (styleProperties.attribute && stylePropertiesValue != null)
      title += `${ToTitleCase(styleProperties.attribute)} ${styleProperties.comparator == 'does not equal' ? '≠' : '='} ${stylePropertiesValue}`;
    // Otherwise, parse sectionKey to determine type of section
    else if (options.sectionKey) {
      if (options.sectionKey.includes('midpoint_section')) title += 'Midpoint Section';
      else title += 'Other Section';
    }
    // no style data, fallback to Undefined Style
    else title += 'Undefined Style';
  }

  return {
    icon: styleProperties.icon,
    style: style,
    parentStyle,
    title: title,
    attribute: styleProperties.attribute,
    value: stylePropertiesValue,
    id: styleProperties.id
  };
}
